module.exports = __webpack_public_path__ + "img/morningicon.aaf20471.svg";